import {
    actionStatusResponse,
    kindResponse,
    ReceiversRequestResponse,
    RequestersRequestResponse,
    RequestResponse,
    StatusResponse

} from "@/types/service-response";
import RequestData from "@/model/RequestData";


export default class Request {
  private constructor(
    readonly actionStatus: actionStatusResponse,
    readonly createdAt: string,
    readonly data: RequestData,
    readonly id: string,
    readonly kind: kindResponse,
    readonly receivers: any,
    readonly requesters: any,
    readonly status: StatusResponse
  ) {}


  static createFromResponse(responseData: RequestResponse): Request {

    return new Request(
        responseData.actionStatus,
        responseData.createdAt,
        RequestData.createFromResponse(responseData.data),
        responseData.id,
        responseData.kind,
        responseData.receivers,
        responseData.requesters,
        responseData.status,
    )
  }

  static createFromResponseList(responseData: RequestResponse[]): Request[] {
    return responseData.map((item:RequestResponse) => {
      return new Request(
          item.actionStatus,
          item.createdAt,
          item.data,
          item.id,
          item.kind,
          item.receivers,
          item.requesters,
          item.status,
      )
    })
  }
}